
import { AuthActionTypes, LOGIN, REGISTER, LOGOUT, SET_USER_PERMISSION } from '../types/authTypes';

export interface AuthState {
  isLoggedIn: boolean;
  userName: string;
  userPermissions: any
}

export const initialState: AuthState = {
  isLoggedIn: false,
  userName: '',
  userPermissions: null
};


const authReducer = (
  state = initialState,
  action: AuthActionTypes,
): AuthState => {
  switch (action.type) {
    case LOGIN:
      return { ...state, isLoggedIn: true };
    case REGISTER:
      return { ...state, isLoggedIn: false };
    case LOGOUT:
      return { ...state, isLoggedIn: false };

    case SET_USER_PERMISSION:
      return { ...state, userPermissions: action.payload };
    default:
      return state;
  }
};


export default authReducer;
